module.exports = __webpack_public_path__ + "img/lite-primary-photo.75ff64ae.jpeg";